"use client";

import { useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { createOrganization } from "../../../api/api";

const OrganizationForm = () => {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await createOrganization({ name });
      // After successful creation, redirect to dashboard
      navigate("/dashboard/mydashboard", { replace: true });
    } catch (err) {
      setError(err.message || "Failed to create organization");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-main-content m-auto m-1230 px-3">
      <Row className="align-items-center">
        <Col lg={6} className="d-none d-lg-block">
          <img
            src="/images/login.jpg"
            className="rounded-3"
            alt="organization setup"
            width={646}
            height={804}
          />
        </Col>

        <Col lg={6}>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-4">
              <label>Organization Name</label>
              <Form.Control
                type="text"
                placeholder="ABC Company Ltd."
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </Form.Group>

            {error && <div className="alert alert-danger">{error}</div>}

            <button type="submit" className="btn btn-primary w-100" disabled={loading}>
              {loading ? "Creating..." : "Next"}
            </button>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default OrganizationForm;
